import { createFileRoute } from '@tanstack/react-router';

import { LabRequestPanel } from '../features/lab-request/lab-request-panel';

/** Lab 생성 신청 — `AC-PF-02-16`. S 계층에 화면이 아직 없어 이 줄이 정본이다 (E14 §2) */
export const Route = createFileRoute('/lab-request')({
  component: LabRequestPanel,
});
